const NAME = "MY_TRAINING";

export const ACTIVITY_STATUS_OPTIONS = {
    completed: "completed",
    pending: "pending", // sin resolver
    pendingCorrection: "pendingCorrection", // si ya respondio y falta que corrija el instructor
    blocked: "blocked" // si necesita hacer otra actividad antes
}

export default NAME;